import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { aioliRouter } from './routing/aioliRouter'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { aioliAccessControl } from './access-control/aioliAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'aioli',
  totem: {
    tool: 'aioli-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [aioliRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.AnalyticsStorefrontPerformance,
      attachToV3: NavEntryPointV3.Performance,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'AI-powered analytics assistant for conversational data insights',
          labelId: 'aioliDomain.title',
          route: 'aioli',
          accessControl: aioliAccessControl,
          id: 'nav-item-aioli',
          positionNavV2: 99,
          positionNavV3: 99,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
